import React, { FC, useState } from 'react'
import { Column, Row } from 'react-table'
import Table from '../../components/Table';
import { Container, Grid, makeStyles, Typography } from '@material-ui/core';
import { DeviceEvent, DeviceLogData } from '../../api/mobilbase/models';
import { useLocation } from 'react-router-dom';
import * as mobilbase from '../../api/mobilbase';
import { RouteLocationProps } from '../../routes/mobilbase';
import APIRequest from '../../components/helpers/APIRequest';

const useStyles = makeStyles((theme) => ({
    paper: {
      marginTop: theme.spacing(3),
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    grid: {
      width: '100%', // Fix IE 11 issue.
      marginTop: theme.spacing(3),
    },
  }));

const DeviceLog: FC = () => {
  const classes = useStyles();
  const routeLocation = useLocation<RouteLocationProps>();
  const {selectedLocationId, selectedDeviceId, selectedDeviceName} = (routeLocation.state) ? routeLocation.state : new RouteLocationProps();
  const [data, setData] = useState<DeviceLogData>({deviceName: "", events: []});
  const [isPending, setIsPending] = useState(false);
  const [run, setRun] = useState(true);

  const columns: Column<DeviceEvent>[] = React.useMemo(
    () => [
      { Header: 'Tid', id: "0", accessor: 'time',
        sortType: (rowA: Row<DeviceEvent>, rowB: Row<DeviceEvent>) => {
            const a = rowA.values.time.split(/-|:| /);
            const b = rowB.values.time.split(/-|:| /);
            return ((a[2] + a[1] + a[0] + a[3] + a[4] + a[5]) < (b[2] + b[1] + b[0] + b[3] + b[4] + b[5])) ? -1 : 1
          }
      },
      { Header: 'Hændelse', id: "1", accessor: 'eventType'},
      { Header: 'Enhed', id: "2", accessor: 'device'},
      { Header: 'Tekst', id: "3", accessor: 'text'}
    ],
    []
  );

  const RequestData = () => {
    return (
      <APIRequest<DeviceLogData> 
          run={run} 
          setRun={setRun}
          pending={isPending}
          setIsPending={setIsPending} 
          req={() => mobilbase.getDeviceLog({locationId: selectedLocationId, deviceId: selectedDeviceId})}
          setData={setData}
      />
    );
  }

  return (
    <Container maxWidth={false}>
      <RequestData />
        <div className={classes.paper}>
            <Typography component="h1" variant="h5">
                Hændelseslog - {((selectedDeviceName) ? selectedDeviceName : "INGEN VALGT")}
            </Typography>
        <div className={classes.grid}>
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Table<DeviceEvent> columns={columns} data={data.events} initialState={undefined} clickEvent={() => {}} update={() => {setRun(true)}} pending={isPending}  text={""}/>
            </Grid>
          </Grid>
        </div>
      </div>
    </Container>  
  );
}

export default DeviceLog;